import { render, staticRenderFns } from "./ConfigClient.vue?vue&type=template&id=f29e9978&scoped=true"
import script from "./ConfigClient.vue?vue&type=script&lang=js"
export * from "./ConfigClient.vue?vue&type=script&lang=js"
import style0 from "./ConfigClient.vue?vue&type=style&index=0&id=f29e9978&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f29e9978",
  null
  
)

export default component.exports